import React, { useEffect } from 'react';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, []);

  return (
    <div className="policy-container">
      <div className="policy-hero">
        <div className="policy-overlay">
          <h1>Privacy Policy</h1>
          <p>How we protect and manage your data</p>
        </div>
      </div>

      <div className="policy-content">
        <div className="policy-header">
          <div className="policy-meta">
            <div className="meta-item">
              <span className="meta-label">Effective Date:</span>
              <span className="meta-value">20-06-2025</span>
            </div>
            <div className="meta-item">
              <span className="meta-label">Last Updated:</span>
              <span className="meta-value">20-06-2025</span>
            </div>
          </div>
          <div className="company-unit">
            <p>A unit of NexSpyder Technologies Pvt. Ltd.</p>
          </div>
        </div>

        <div className="policy-introduction">
          <p>
            At Procart India, we value your privacy and are committed to protecting your personal data.
            This Privacy Policy explains how we collect, use, store, share, and safeguard your information
            when you use our website, mobile platform, or services. By accessing or using any part of
            our platform (www.procartindia.com), you agree to the terms described in this policy.
          </p>
        </div>

        <div className="policy-section">
          <h2>Legal Compliance</h2>
          <div className="section-content">
            <p>
              We follow Indian data protection laws including the Information Technology Act, 2000, the IT
              (Reasonable Security Practices and Procedures and Sensitive Personal Data or Information)
              Rules, 2011, and the Digital Personal Data Protection Act, 2023 (DPDP Act). These laws
              require us to handle your data securely, transparently, and only for lawful, specific purposes
              with your consent.
            </p>
          </div>
        </div>

        <div className="policy-section">
          <h2>Information We Collect</h2>
          <div className="section-content">
            <p>
              We collect personal information such as your name, phone number, email address, shipping
              and billing details, and payment method (secured via trusted payment gateways). We may
              also collect technical data like your IP address, browser type, device type, location, and
              usage behaviour on our website to improve your user experience. Additionally, any files or
              project information you share with us for technical support or custom services are stored
              securely and handled with confidentiality.
            </p>
          </div>
        </div>

        <div className="policy-section">
          <h2>How We Use Your Information</h2>
          <div className="section-content">
            <p>
              Your information is used to process and fulfil orders, provide delivery updates, handle
              support requests, offer project guidance, personalize your shopping experience, and
              improve our services. With your permission, we may also send updates, offers, or
              newsletters. You can opt out of marketing emails anytime.
            </p>
          </div>
        </div>

        <div className="policy-section">
          <h2>Information Sharing</h2>
          <div className="section-content">
            <p>
              We never sell your personal data. Your information is only shared with third-party service
              providers when necessary—such as logistics partners for delivery, payment processors for
              secure transactions, vendor partners for dispatching products, or analytics tools for
              improving site performance. In certain cases, we may also share information if required by
              legal or regulatory authorities.
            </p>
          </div>
        </div>

        <div className="policy-section">
          <h2>Data Security</h2>
          <div className="section-content">
            <p>
              Procart India implements strong security measures including SSL encryption, secure servers,
              access control, and routine security audits to protect your data. We also use cookies and
              similar tools to enhance website functionality and monitor performance. You can manage
              your cookie preferences through your browser settings.
            </p>
          </div>
        </div>

        <div className="policy-section">
          <h2>Your Rights</h2>
          <div className="section-content">
            <p>
              In accordance with the DPDP Act, you have full rights over your data. This includes the right
              to access your data, request corrections, withdraw consent, or request erasure of your data,
              subject to legal requirements. You may contact us at any time for these requests.
            </p>
          </div>
        </div>

        <div className="policy-section">
          <h2>Data Retention</h2>
          <div className="section-content">
            <p>
              We retain your information only for as long as necessary to provide services, comply with
              legal obligations, resolve disputes, or enforce agreements. If your account becomes inactive,
              we may retain your data for a limited period, after which it will be securely deleted.
            </p>
          </div>
        </div>

        <div className="policy-section">
          <h2>Children's Privacy</h2>
          <div className="section-content">
            <p>
              We do not knowingly collect information from children under 13 years of age. If such data is
              found, it will be removed promptly upon verification.
            </p>
          </div>
        </div>

        <div className="policy-section">
          <h2>Policy Updates</h2>
          <div className="section-content">
            <p>
              We may update this Privacy Policy from time to time. Any changes will be published on this
              page with an updated "Last Updated" date. If changes are significant, we will notify users via
              email or prominent alerts on our website.
            </p>
          </div>
        </div>

        <div className="policy-section contact-section">
          <h2>Contact Us</h2>
          <div className="section-content">
            <p>
              If you have any questions, concerns, or requests regarding your privacy or data rights, you
              can reach out to us directly:
            </p>
            <div className="contact-details">
              <div className="contact-item">
                <span className="contact-label">Procart India – Data Protection Officer</span>
              </div>
              <div className="contact-item">
                <span className="contact-label">Email:</span>
                <span className="contact-value">privacy@procartindia.com</span>
              </div>
              <div className="contact-item">
                <span className="contact-label">Website:</span>
                <span className="contact-value">www.procartindia.in</span>
              </div>
            </div>
          </div>
        </div>

        <div className="policy-conclusion">
          <p>
            We're committed to creating a safe, transparent, and trusted experience for every customer,
            builder, and maker on our platform.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;